import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createReturnReasonConfigBottom, createReturnReasonConfigStuff, createReturnReasonConfigTop } from "../mockCore";

export function getExchange({ productId }) {
    if (productId === "1") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/lexington sweater - Light Blue Melange.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Light Blue Melange",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/lexington sweater - Light Blue Melange.png",
                    originalVariant: true,
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Light Blue Melange",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/lexington sweater - Light Blue Melange.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Light Blue Melange",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/lexington sweater - White - Blue Stripe.png",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White/Blue Stripe",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/lexington sweater - White - Blue Stripe.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White/Blue Stripe",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/lexington sweater - White - Blue Stripe.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "White/Blue Stripe",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "2") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/lexington pants - Dark Blue.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Dark Blue",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/lexington pants - Dark Blue.png",
                    originalVariant: true,
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Dark Blue",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/lexington pants - Dark Blue.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Dark Blue",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/lexington pants - Light Brown.png",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Light Brown",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/lexington pants - Light Brown.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Light Brown",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/lexington pants - Light Brown.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Light Brown",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "3") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/lexington towel - Steel Blue.png",
                    inventoryMerchant: 7,
                    inventoryTurnr: 0,
                    inventoryTotal: 7,
                    properties: [
                        {
                            type: "Color",
                            value: "Steel Blue",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/lexington towel - Apricot.png",
                    inventoryMerchant: 7,
                    inventoryTurnr: 0,
                    inventoryTotal: 7,
                    properties: [
                        {
                            type: "Color",
                            value: "Apricot",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/lexington towel - White.png",
                    inventoryMerchant: 7,
                    inventoryTurnr: 0,
                    inventoryTotal: 7,
                    properties: [
                        {
                            type: "Color",
                            value: "White",
                        },
                    ],
                },
            ],
        };
    }

    return {
        exchangeAlternatives: [
            {
                id: "1",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "2",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                id: "3",
                inventoryMerchant: 0,
                inventoryTurnr: 1,
                inventoryTotal: 1,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Green",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
        ],
    };
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        pickupDateSelectionAllowed: true,
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: [
            {
                productVariantId: 10,
                sessionItemId: 1,
                productName: "Marline Organic Cotton Sweater",
                imageSrc: "/mocks/lexington sweater - Light Blue Melange.png",
                imageAlt: "/mocks/lexington sweater - Light Blue Melange.png",
                quantity: 1,
                purchasePrice: 995,
                properties: [
                    {
                        type: "Size",
                        value: "S",
                    },
                    {
                        type: "Color",
                        value: "Light Blue Melange",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
            {
                productVariantId: 20,
                sessionItemId: 2,
                productName: "Cleo Linen Pants",
                imageSrc: "/mocks/lexington pants - Dark Blue.png",
                imageAlt: "/mocks/lexington pants - Dark Blue.png",
                quantity: 1,
                purchasePrice: 1595,
                properties: [
                    {
                        type: "Size",
                        value: "S",
                    },
                    {
                        type: "Color",
                        value: "Dark Blue",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigBottom(),
            },
            {
                productVariantId: 30,
                sessionItemId: 3,
                productName: "Original Towel x4",
                imageSrc: "/mocks/lexington towel - Gray Olive.png",
                imageAlt: "/mocks/lexington towel - Gray Olive.png",
                quantity: 1,
                purchasePrice: 500,
                properties: [
                    {
                        type: "Color",
                        value: "Gray Olive",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigStuff(),
            },
        ],
    };
}
